import { Suspense } from 'react';
import dollarSignLottie from '@public/_nextassets_/lottie/dollar-sign.json';
import styles from './claimStoreCreditsModal.module.scss';
import dynamic from 'next/dynamic';

// Dynamically import the Lottie component
const Lottie = dynamic(() => import('react-lottie-player'), { ssr: false });

const SuccessLottie = () => (
  <Suspense fallback={<div>Loading animation...</div>}>
    <Lottie animationData={dollarSignLottie} play loop={false} className={styles.lottie} />
  </Suspense>
);

export default SuccessLottie;
